import MuiLinearProgress, {
  LinearProgressProps as MuiLinearProgressProps,
} from '@mui/material/LinearProgress';

export interface LinearProgressProps extends MuiLinearProgressProps {
  rounded?: boolean;
}

export const LinearProgress: React.FC<LinearProgressProps> = ({
  rounded = true,
  sx,
  ...props
}) => {
  return (
    <MuiLinearProgress
      sx={[
        rounded && {
          borderRadius: 1,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
};
